import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import { AuthNavigate } from './auth-navigate';

export const Navigation = () => {
  return (
    <BrowserRouter>
      <AuthNavigate />
    </BrowserRouter>
  );
};
